import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useFeatures } from '../contexts/FeaturesContext';
import NotFoundPage from '../pages/NotFoundPage';

/**
 * Wraps a route that only exists while a deployment feature is on.
 *
 * While the feature answer is still in flight we render a spinner rather than
 * Not Found — a dev user landing straight on /properties must not be bounced
 * before the flags arrive. Once loaded, an off feature is indistinguishable
 * from a URL that was never a route.
 */
export default function FeatureGate({ feature, children }) {
  const features = useFeatures();

  if (!features.loaded) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return features[feature] ? children : <NotFoundPage />;
}
